<template>
    <div>
        <v-form>
            <v-container>
                <v-flex style="margin-top: 30px;">
                    <v-row>
                        <h4>Start date:</h4>
                        <label for="input-field">
                            <span class="required">*</span>
                        </label>
                            <input style="margin-right: 50px; margin-left: 15px; border: 3px solid #bbb" type="date" v-bind:max="maxDate" v-model="startDate">
                        <h4>End date :</h4>
                        <label for="input-field">
                            <span class="required">*</span>
                        </label>
                            <input style="margin-right: 50px; margin-left: 15px; border: 3px solid #bbb" type="date" :min="startDate" v-bind:max="maxDate" v-model="endDate">
                        <v-btn @click="apiCallEligibility(startDate,endDate)"  style="margin-right: 10px;">Submit</v-btn>
                    </v-row>
                    <v-card style="margin-top: 40px;">
                        <v-row>
                            <v-data-table
                                style="width: 500px; margin-right: 50px;"
                                v-model="selectedData"
                                :headers="headers"
                                :loading="loadingItem"
                                :items="filteredData"
                                item-key="date">
                            </v-data-table>
                            <div>
                                <p style="font-style: italic; font-weight: bold;" v-text="pretext + text"></p>
                            </div>
                        </v-row>
                    </v-card>
                </v-flex>
            </v-container>
        </v-form>
    </div>
</template>
<script>
import moment from 'moment'
let rh = require('@/components/APIs/RequestHandler')

export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    startDate: moment().date(1).toISOString().slice(0, 10),
    endDate: moment().toISOString().slice(0, 10),
    startingDate: '',
    endingDate: '',
    selectedData: [],
    loadingItem: false,
    headers: [
      { text: 'Date', value: 'date' },
      { text: 'Balance', value: 'balance' }
    ],
    filteredData: [],
    pretext: 'Change in Balance:    ',
    text: '',
    formattedDate: ''
  }),
  watch: {
    startDate (newVal, oldVal) {
      this.clearEndDate()
    }
  },
  computed: {
    maxDate () {
      const now = new Date()
      const year = now.getFullYear()
      const month = (now.getMonth() + 1).toString().padStart(2, '0')
      const day = now.getDate().toString().padStart(2, '0')
      return `${year}-${month}-${day}`
    }
  },
  methods: {
    async apiCallEligibility (startingDate, endingDate) {
      if (startingDate !== '' && endingDate !== '') {
        this.apiCall(startingDate, endingDate)
      }
    },
    clearEndDate () {
      if (this.startDate > this.endDate) {
        this.endDate = ''
        return this.endDate
      }
      return this.endDate
    },
    async apiCall (sdate, eDate) {
      this.selectedData = []
      this.filteredData = []
      this.loadingItem = true
      this.text = ''
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_FUNDS_XFER}/vault/user/${this.user.userId}/status?fromDate=${sdate}&toDate=${eDate}`
      var getResponse = await rh.default
        .get(endpoint, true)
        .catch((e) => {
          this.errors.push(e)
          throw e
        })
        .then((value) => {
        //   this.users = value.data
          this.filteredData = value.data.vaultBalances
          if (value.data.balanceChange === null) {
            this.text = this.text + '$' + 0.00
          } else {
            this.text = this.text + '$' + value.data.balanceChange
          }
        })
      this.loadingItem = false
    }
  }
}
</script>
<style>
.required {
  color: red;
}
</style>
